export function clearToYearIfBeforeFrom(
    fromYear: number | null | undefined,
    toYear: number | null | undefined
): number | null | undefined {
    if (fromYear != null && toYear != null && toYear < fromYear) {
        return null;
    }

    return toYear;
}

export function getToYears(
    years: number[],
    fromYear: number | null | undefined
): number[] {
    if (fromYear == null) {
        return years;
    }

    return years.filter(year => year >= fromYear);
}

export function syncFilterToYearAfterFromChange<T extends object>(
    filterData: T,
    years: number[],
    fromKey: keyof T & string,
    toKey: keyof T & string
): number[] {
    const fromYear = filterData[fromKey] as number | null | undefined;
    const toYears = getToYears(years, fromYear);
    const filter = filterData as Record<string, number | null | undefined>;
    filter[toKey] = clearToYearIfBeforeFrom(fromYear, filter[toKey]);

    return toYears;
}
